import { useState } from "react";

import { IS_NODE_BROWSERLESS } from "@/__main__/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

// Resolves after the next repaint,
// this ensures all previous CSS properties are applied so they may transition.
// Precedent for rAF(rAF(() => {})):
// https://github.com/tailwindlabs/headlessui/blob/5af3bd4b7164a0205ac70c179d8e9651afbb0a72/packages/%40headlessui-react/src/utils/disposables.ts#L25-L29
export default function nextFrame(
  callback: Parameters<typeof requestAnimationFrame>[0],
): { frame: number } {
  if (IS_NODE_BROWSERLESS) return { frame: 0 };

  // time is omitted because who needs it?
  let frame =
    // requestAnimationFrame ensures the callback is called BEFORE the next repaint
    requestAnimationFrame(() => {
      // calling it a second time ensures the callback is called AFTER the next repaint
      frame = requestAnimationFrame(callback);
    });

  return { frame };
}

/**
 * Just a way to defer rendering until next frame
 */
export function useNextFrame() {
  const [isNext, setNext] = useState(false);

  if (!IS_NODE_BROWSERLESS) {
    globals.requestAnimationFrame(() => {
      setNext(true);
    });
  }

  return isNext;
}
